import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsContainersType extends Component{ 

    constructor(props){
      super(props);

      this.state={
          containertypes:[],
          modalTitle:"",
          containertypename:"",
          containertypeid:0,

          ContainerTypeIdFilter:"",
          ContainerTypeNameFilter:"",
          containertypesWithoutFilter:[],
          containertypeNames: [],
          containertypeExists: false,
      }
  }

  FilterFn(){
    var ContainerTypeIdFilter=this.state.ContainerTypeIdFilter;
    var ContainerTypeNameFilter = this.state.ContainerTypeNameFilter;

    var filteredData=this.state.containertypesWithoutFilter.filter(
        function(el){
            return el.containertypeid.toString().toLowerCase().includes(
                ContainerTypeIdFilter.toString().trim().toLowerCase()
            )&&
            el.containertypename.toString().toLowerCase().includes(
                ContainerTypeNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({containertypes:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.containertypesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({containertypes:sortedData});

}

changeContainerTypeIdFilter = (e)=>{
  this.state.ContainerTypeIdFilter=e.target.value;
  this.FilterFn();
}
changeContainerTypeNameFilter = (e)=>{
  this.state.ContainerTypeNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/containertypes/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({containertypes:data,containertypesWithoutFilter:data});
  });
}


fetchContainertypeNames() {
  axiosService.get('/containertypes/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const containertypeNames = data.map(item => item.containertypename);
      this.setState({ containertypeNames: containertypeNames });
    })
    .catch(error => {
      console.error("Error fetching containertype names:", error);
    });
}

checkContainertypeExists = (event) => {
  const enteredContainertype = event.target.value.toLowerCase(); // Convert to lowercase
  const { containertypeNames } = this.state;
  const containertypeExists = containertypeNames.some((containertype) => containertype.toLowerCase() === enteredContainertype);
  this.setState({ containertypeExists });
};

componentDidMount(){
  this.refreshList();
  this.fetchContainertypeNames();
}

changeContainerTypeName =(e)=>{
  this.setState({containertypename:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add ContainerType",
      containertypeid:0,
      containertypename: "",
      costgridsubtaskname:"",
      containertypeExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit ContainerType",
      containertypeid:dep.containertypeid,
      containertypename:dep.containertypename,
      costgridsubtaskname:dep.costgridsubtaskname,
      initialContainertypename:dep.containertypename,
      containertypeExists: false,
  });
}

createClick() {
  const { containertypename, containertypeNames } = this.state;

  if (!containertypename) {
    alert('Container Type Name is required');
    return;
  }

  if (containertypeNames.some(name => name.toLowerCase() === containertypename.toLowerCase())) {
    alert('Containertype already exists. Please provide a unique Containertype Name.');
    return;
  }

  axiosService.post('/containertypes/', {
    containertypename: containertypename
  })
    .then(result => {
      alert('ContainerType created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){
  const { containertypename, initialContainertypename, containertypeNames } = this.state;

   // Check if any changes are detected
   if (
    containertypename === initialContainertypename
  ) {
    alert('No changes detected');
    return;
  }

  if (
    containertypeNames.some(
      (existingContainertype) =>
        existingContainertype.toLowerCase() === containertypename.toLowerCase()
    )
  ) {
    alert('Containertype already exists. Please provide a unique Containertype Name.');
    return;
  }

  if (!containertypename) {
    alert('Container Type Name is required');
    return;
  }

  axiosService.patch('/containertypes/'+id+'/',{
      containertypeid:this.state.containertypeid,
      containertypename:this.state.containertypename
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/containertypes/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      containertypes,
      modalTitle,
      containertypeid,
      containertypename,
      containertypeExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeContainerTypeIdFilter}
      placeholder="Filter"/>
      

      </div>
      ContainerTypeId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeContainerTypeNameFilter}
      placeholder="Filter"/>
      </div>
      ContainerType

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {containertypes.map(dep=>
      <tr key={dep.containertypeid} className="row-hover">
          <td className="table-text">{dep.containertypeid}</td>
          <td className="table-text">{dep.containertypename}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Containertype</span>
          <input
            type="text"
            className={`form-control ${containertypeExists ? "is-invalid" : ""}`}
            value={containertypename}
            onChange={this.changeContainerTypeName}
            onBlur={this.checkContainertypeExists} 
            style={{ fontSize: "12px" }} 
          />
          {containertypeExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Containertype already exists.</div>}
        </div>

        {containertypeid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {containertypeid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(containertypeid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

